/**
 * @generated SignedSource<<4f057a57ea5ac30b91b0234ae1003229>>
 * @relayHash 5231bce03a32e81e6c5987a3ed1378ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e35712e7fb378f1a2d96df9f599c719ad56ddd4401b82ee58bb68610b68cc57

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentNav3Query } from './PopupContentNav3Query.graphql';

const node: PreloadableConcreteRequest<PopupContentNav3Query> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3e35712e7fb378f1a2d96df9f599c719ad56ddd4401b82ee58bb68610b68cc57",
    "metadata": {},
    "name": "PopupContentNav3Query",
    "operationKind": "query",
    "text": null
  }
};

export default node;
